import React from "react";
import { APP_DISPLAY_NAME } from "../config/appBranding";

/** Shown at the bottom of every in-app route (dashboard + settings). */
export default function AppFooter() {
  return (
    <footer className="age-app-footer" role="contentinfo">
      <p className="age-app-footer__text">
        {APP_DISPLAY_NAME} — free shipping progress bars and upsells for your Shopify store.
      </p>
    </footer>
  );
}
